import { Save } from "lucide-react";

const AdminField = ({ label, value, onChange, type = "text", placeholder = "", rows = 1 }) => (
  <div>
    <label className="block text-xs font-medium text-neutral-500 font-['Manrope'] mb-2 uppercase tracking-wider">
      {label}
    </label>
    {rows > 1 ? (
      <textarea
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        className="w-full px-4 py-3 rounded-xl bg-white/[0.04] border border-white/[0.08] text-white text-sm font-['Manrope']
          placeholder:text-neutral-600 resize-none
          transition-colors duration-300
          focus:outline-none focus:border-white/[0.2] focus:bg-white/[0.06]"
      />
    ) : (
      <input
        type={type}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full px-4 py-3 rounded-xl bg-white/[0.04] border border-white/[0.08] text-white text-sm font-['Manrope']
          placeholder:text-neutral-600
          transition-colors duration-300
          focus:outline-none focus:border-white/[0.2] focus:bg-white/[0.06]"
      />
    )}
  </div>
);

const AdminSaveButton = ({ onClick, saving }) => (
  <button
    data-testid="save-section-button"
    onClick={onClick}
    disabled={saving}
    className="inline-flex items-center gap-2 px-6 py-2.5 rounded-xl bg-white text-[#030303] text-sm font-semibold tracking-tight font-['Manrope']
      transition-all duration-300
      hover:bg-neutral-200
      disabled:opacity-50 disabled:cursor-not-allowed
      focus:outline-none focus:ring-2 focus:ring-white/50 focus:ring-offset-2 focus:ring-offset-[#030303]"
  >
    <Save className="w-4 h-4" />
    {saving ? "Saving..." : "Save Changes"}
  </button>
);

const AdminSection = ({ title, description, children }) => (
  <div className="mb-8 pb-8 border-b border-white/[0.06] last:border-0">
    {title && (
      <div className="mb-5">
        <h3 className="font-['Outfit'] text-lg font-medium text-white tracking-tight">{title}</h3>
        {description && <p className="text-xs text-neutral-500 font-['Manrope'] mt-1">{description}</p>}
      </div>
    )}
    <div className="space-y-4">
      {children}
    </div>
  </div>
);

export { AdminField, AdminSaveButton, AdminSection };
